export default {
    modalGenerateImageVariations: {
        imageAIHeader: 'Create image using AI',
        requestFailed: 'Request failed',
        describeYourImage: 'Describe your image',
        numberOfVariations: 'Number of variations',
        chooseStyle: 'Choose your image style',
        descriptionPlaceholder: '(eg) A field of mustard flowers on a summer day with oak trees',
        clear: 'Clear',
        generate: 'Generate',
        seeAll: 'See All',
        tryAnExample: 'Try an example',
        tryAnother: 'Try another',
    },
};
